var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{attrs:{"breadcrumb":_vm.breadcrumb,"view":"sm","header":"center"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Пополнить баланс")]},proxy:true}])},[_c('payment-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }